import React, { useState, useEffect } from 'react';
import NavBar, { infoUtente, loadNav } from '../../visualComponents/NavBarVend.js';
import { ArrowDownAZ, ArrowUpAZ } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import QRCodeGenerator from '../../components/QRCodeGenerator.js';
import * as XLSX from 'xlsx';
import Loader from '../../visualComponents/Loader.js';
import Tooltip from "../../components/Tooltip.js";

let isLoading = true;

const PopUp = ({ isVisible, setIsVisible }) => {
    const [quantita, setQuantita] = useState(0);

    const closeModal = () => {
        setIsVisible(false);
    };

    const handleConferma = async () => {

        if (quantita <= 0) {
            alert("Inserire una quantità valida");
            return;
        }
        isLoading = true;

        let codici = [];

        for (let i = 0; i < quantita; i++) {
            let codice = await generateUniqueID();
            codici.push(codice);
        }

        try {
            const response = await fetch("/addQrCodes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ QRCode: codici, ID: infoUtente.ID })
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            } else {
                const qrCodes = await generaQrCode(codici);

                //open window to print all qrCodes
                const printWindow = window.open("", "", "width=600,height=600");
                printWindow.document.write("<html><head><title>QRCode</title></head><body>");
                qrCodes.forEach((d) => {
                    printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
                });
                printWindow.document.write("</body></html>");
                printWindow.document.close();
                await new Promise((resolve) => setTimeout(resolve, 500));
                printWindow.print();

                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'aggiunta dei codici, riprovare più tardi");
            console.log(error);
            window.location.reload();
        }

    };

    const generaQrCode = async (ids) => {
        let qrCodes = [];
        for (let i = 0; i < ids.length; i++) {
            qrCodes.push(await QRCodeGenerator.generateQRCode(ids[i]));
        }
        return qrCodes;
    };

    const generateUniqueID = async () => {
        let tempID = `${Date.now()}-${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
        return tempID;
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-">
                    <h2 className="text-xl font-bold justify-self-center">Aggiungi Codici</h2>
                </div>
                <div>
                    <div className="grid grid-cols-2 mx-5 mb-2 mt-4">
                        <p className="">Quantità: </p>
                        <input type="number" className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" onChange={(e) => setQuantita(e.target.value)} />
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ data, check, onCheckChange }) => {
    return (
        <div className="grid grid-cols-4 gap-1 mt-2">
            <div className='flex items-center justify-end gap-4'>
                <input id={data[0]} type="checkbox" className='w-5 h-5 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1' checked={check} onChange={onCheckChange} />
            </div>
            <div className="col-span-2 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 text-center break-words">
                <div>{data.CodiceUnivoco}</div>
                <div>{data.DataCreazione}</div>
            </div>
            <div className="flex items-center gap-1 ">
            </div>
        </div>
    );
};

const CodiciVenditore = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Codice", dbCode: "CodiceUnivoco", ascending: true, filter: "text" },
        { value: "Data Creazione", dbCode: "DataCreazione", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        CodiceUnivoco: "",
        DataCreazione: ""
    });
    const [data, setData] = useState([]);
    const [archive, setArchive] = useState(false);
    const [viewData, setViewData] = useState([]);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data);
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData);
    }, [filters]);

    const onload = async () => {
        //getInfoUtente
        try {
            isLoading = true;

            await loadNav();

            const r2 = await fetch("/getQRCodeByUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ID: infoUtente.ID })
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate("/dashVenditore");
            } else {
                isLoading = false;
                setData(rd2.map((d) => ({ value: d, checked: false })));
            };

        } catch (error) {
            alert("Errore nel caricamento della pagina, riprovare più tardi");
            console.log(error);
            navigate("/dashVenditore");
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const handleCheckTotale = () => {
        let checkTotale = document.getElementById("tot").checked;
        let newData = [...data];
        newData.forEach((d) => d.checked = checkTotale);
        setData(newData);
    };

    const handleCheckChange = (id) => {
        let newData = [...data];
        newData.forEach((d, index) => {
            if (d["value"]["CodiceUnivoco"] === id) d.checked = !d.checked;
        });
        setData(newData);
    };

    const handleStampa = async () => {
        const selectedElements = viewData.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            alert("Selezionare almeno un elemento");
            return;
        }
        const qrCodes = await generaQrCode(selectedElements);

        //open window to print all qrCodes
        const printWindow = window.open("", "", "width=600,height=600");
        printWindow.document.write("<html><head><title>QRCode</title></head><body>");
        qrCodes.forEach((d) => {
            printWindow.document.write(`<img src="${d}" alt="QRCode non disponibile" />`);
        });
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        await new Promise((resolve) => setTimeout(resolve, 500));
        printWindow.print();
    };

    const handleElimina = async () => {

        if (!window.confirm("Sei sicuro di voler eliminare i codici selezionati?")) return;

        isLoading = true;
        const selectedElements = viewData.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            alert("Selezionare almeno un elemento");
            return;
        }

        try {
            const response = await fetch("/eliminaQrCodes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ QRCode: selectedElements })
            });

            if (response.status === 500) {
                const rd = await response.json();
                alert(rd.error);
                console.log(rd.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'eliminazione dei codici, riprovare più tardi");
            console.log(error);
            window.location.reload();
        }
    };

    const handleExport = () => {
        const selectedElements = viewData.filter((d) => d.checked).map(d => ({ Codice: d.value["CodiceUnivoco"], DataCreazione: d.value["DataCreazione"] }));
        if (selectedElements.length === 0) {
            alert("Selezionare almeno un elemento");
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(selectedElements);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const generaQrCode = async (ids) => {
        let qrCodes = [];
        for (let i = 0; i < ids.length; i++) {
            qrCodes.push(await QRCodeGenerator.generateQRCode(ids[i]));
        }
        return qrCodes;
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"CODICI QR"} />
            {isLoading && <Loader />}
            <div className="p-4 bg-white dark:bg-gray-800 text-black dark:text-white">
                <div className="mt-14">
                    <div className='flex justify-center'>
                        <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded" onClick={() => setIsPopUpVisible(true)}>
                            Aggiungi Codici
                        </button>
                    </div>
                    <div className='flex justify-center gap-4'>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleStampa}>
                            Stampa QRCode
                        </button>
                        <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleElimina}>
                            Elimina QRCode
                        </button>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleExport}>
                            Export
                        </button>
                    </div>
                    <div id="tabella">
                        <div className="grid grid-cols-4 gap-1 mt-4">
                            <div className='flex items-center justify-end gap-4'>
                                <input id="tot" type="checkbox" className='w-5 h-5' onChange={handleCheckTotale} />
                            </div>
                            <div className="col-span-2 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 font-bold text-center">
                                {
                                    indexTabella.map((d, index) => (
                                        <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                            <Tooltip content="Ordina">
                                                <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                    {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                                </button>
                                            </Tooltip>
                                        </div>
                                    ))
                                }
                            </div>
                            <div></div>
                        </div>
                        <div className="grid grid-cols-4 gap-4 mt-2">
                            <div className=''>
                            </div>
                            <div className="col-span-2 rounded-lg grid grid-cols-2 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                                {
                                    indexTabella.map((d, index) => (
                                        <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 6 ? "pl-2" : "px-2"}`}>
                                            <input
                                                type={d.filter}
                                                placeholder={d.value}
                                                value={filters[d.dbCode]}
                                                className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                                onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                            <div></div>
                        </div>
                        {viewData.map((d, index) => (
                            <TableRow key={index} data={d.value} check={d.checked} onCheckChange={() => handleCheckChange(d.value["CodiceUnivoco"])} />
                        ))}
                    </div>

                </div>
            </div>
            <PopUp isVisible={isPopUpVisible} setIsVisible={setIsPopUpVisible} />
        </div>
    );
};

export default CodiciVenditore;